/**
 * @generated SignedSource<<bf3aafe40c305dddad3de78172752665>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClubLogoFragment_UnauthenticatedClub$data = {
  readonly logoImage: {
    readonly publicId: string;
  } | null | undefined;
  readonly slug: string;
  readonly " $fragmentType": "ClubLogoFragment_UnauthenticatedClub";
};
export type ClubLogoFragment_UnauthenticatedClub$key = {
  readonly " $data"?: ClubLogoFragment_UnauthenticatedClub$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClubLogoFragment_UnauthenticatedClub">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClubLogoFragment_UnauthenticatedClub",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnauthenticatedImage",
      "kind": "LinkedField",
      "name": "logoImage",
      "plural": false,
      "selections": [
        {
          "alias": "publicId",
          "args": null,
          "kind": "ScalarField",
          "name": "renderingKey",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UnauthenticatedClub",
  "abstractKey": null
};

(node as any).hash = "1401e0759d5e55c19783fb1d2ed7a0d8";

export default node;
